import type { SiteCountryCodeUppercase } from "../../../types-and-definitions/locale-defs/Locales.js";

export function getSourceWebsite (siteCountryCode: SiteCountryCodeUppercase) {
  return `mastercontrol.com ${ siteCountryCode.toUpperCase() }`;
}
